fx.ns("shared.components", class CoverThumbPhoto extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    load()
    {
        super.load();
        
        if (this.empty)
        {
            if (this.emptyPlaceHolder)
                this.loadImage(this.emptyPlaceHolder);
            else
                this.ready();
        }
        else
        {
            let url = this._fullQuality ? this._fullUrl() : this.photo.getUrl(this.data.content_type);

            // nothing the browser can show yet : a photo still being read (no picture of it at all), or
            // a HEIC on its way to the server, which makes the JPEG of it (the stage shows them loading
            // too). Left out at once, and uploading says why
            if (!shared.components.CoverThumbPhoto.showable(this.photo, url))
            {
                this.uploading = true;
                return this.onLoadError();
            }

            this.loadImage(url);
        }

    }

    // whether the browser has a picture of the photo to draw : url, the one it would load
    static showable(photo, url)
    {
        if (url === undefined)
            url = photo.getUrl("");

        return !!url && url != "undefined" && !photo.initializing && !(photo.isHeic && !photo.url);
    }

    // the photo's frame in its place, as the stage gave it (x_inner … height_inner) ; when it has none
    // yet — the stage had no picture to measure, a HEIC photo still being sent —, the frame the stage
    // gives a new photo (Photo.fill(), without the faces) : filling the place, centred. Without it
    // the photo was drawn 0 wide, and the page came out complete with nothing in the place
    get elementXInner() { let fill = this._fill(); return fill ? fill.x * this.creationSize.ratio : super.elementXInner; }
    get elementYInner() { let fill = this._fill(); return fill ? fill.y * this.creationSize.ratio : super.elementYInner; }
    get elementWidthInner() { let fill = this._fill(); return fill ? fill.width * this.creationSize.ratio : super.elementWidthInner; }
    get elementHeightInner() { let fill = this._fill(); return fill ? fill.height * this.creationSize.ratio : super.elementHeightInner; }

    // millimetres, like the component's own values ; null while there is a frame, or no picture yet
    _fill()
    {
        let data = this.data,
            image = this.image;

        if (this.empty || (Number(data.width_inner) && Number(data.height_inner)) || !image || !image.naturalWidth || !image.naturalHeight)
            return null;

        let width = Number(data.width),
            height = Number(data.height),
            ratio = image.naturalWidth / image.naturalHeight,
            turned = (this.elementRotationInner == 90 || this.elementRotationInner == 270),
            widthInner,
            heightInner;

        // turned, the picture's width runs along the place's height
        if (!turned)
        {
            widthInner = Math.max(width, height * ratio);
            heightInner = widthInner / ratio;
        }
        else
        {
            heightInner = Math.max(width, height / ratio);
            widthInner = heightInner * ratio;
        }

        let shownWidth = turned ? heightInner : widthInner,
            shownHeight = turned ? widthInner : heightInner;

        return { x : -(shownWidth - width) / 2, y : -(shownHeight - height) / 2, width : widthInner, height : heightInner };
    }

    // the photo at full resolution, in its version (an AI look) when it has one
    _fullUrl()
    {
        let effect = this.data.content_type,
            urls = effect && this.photo.urls && this.photo.urls[effect];

        return (urls && urls.full) || (!effect && this.photo.url) || this.photo.getUrl(effect);
    }

    // drawn more than 15 % larger than the picture loaded (ThumbGenerator's upscaled)
    get upscaled()
    {
        let image = this.image;
        if (this.empty || !image || !image.naturalWidth || this.failed)
            return false;

        let turned = (this.elementRotationInner == 90 || this.elementRotationInner == 270),
            width = turned ? this.elementHeightInner : this.elementWidthInner;

        return width > image.naturalWidth * 1.15;
    }

    onImageLoaded()
    {
        this._tmpCanvas = document.createElement('canvas');
        this._tmpCanvas.width = this.elementWidth;
        this._tmpCanvas.height = this.elementHeight;
        this._tmpcontext = this._tmpCanvas.getContext('2d');

        this._tmpImgcanvas = document.createElement('canvas');
        
        if (this.elementRotationInner == 0 || this.elementRotationInner == 180)
        {
            this._tmpImgcanvas.width = this.image.width;
            this._tmpImgcanvas.height = this.image.height;
        }
        else
        {
            this._tmpImgcanvas.width = this.image.height;
            this._tmpImgcanvas.height = this.image.width;
        }

        var imgcontext = this._tmpImgcanvas.getContext('2d');
        this._tmpcontext.translate(this._tmpImgcanvas.width/2, this._tmpImgcanvas.height/2);
        imgcontext.rotate(this.elementRotationInner*this.TO_RADIANS);

        if (this.elementRotationInner == 0)
            imgcontext.drawImage(this.image, 0, 0, this.image.width, this.image.height);
        else
        if (this.elementRotationInner == 90)
            imgcontext.drawImage(this.image, 0, -this.image.height, this.image.width, this.image.height);
        else
        if (this.elementRotationInner == 180)
            imgcontext.drawImage(this.image, -this.image.width, -this.image.height, this.image.width, this.image.height);
        else
        if (this.elementRotationInner == 270)
            imgcontext.drawImage(this.image, -this.image.width, 0, this.image.width, this.image.height);
    
        imgcontext.rotate(-this.elementRotationInner*this.TO_RADIANS);
        this._tmpcontext.translate(-this._tmpImgcanvas.width/2, -this._tmpImgcanvas.height/2);

        // the photo's filter and settings (effectName, luminosity, saturation, contrast), as the stage shows them
        if (filters.PhotoFilters.isPlain(this.data))
            return this._loadMask();

        this._filtered(this._tmpImgcanvas).then((picture) => {
            if (this.late)
                return;

            this._tmpImgcanvas = picture;
            this._loadMask();
        });
    }

    /**
     * The picture through the stage's SVG filter (filters.PhotoFilters.chain()) : an SVG of the
     * picture with the filter, drawn as an image — a canvas has no SVG filters of its own, and
     * ctx.filter = url(#…) is Chrome only. The picture goes in as a data URL, an SVG drawn as an image
     * loading nothing from outside, and such an SVG leaves the canvas exportable. The picture as it
     * was if anything fails.
     * @return {Promise} an Image, or the canvas given
     */
    _filtered(canvas)
    {
        return new Promise((resolve) => {
            try {
                let width = canvas.width,
                    height = canvas.height,
                    draw = SVG(document.createElement("div")).size(width, height),
                    image = draw.image(canvas.toDataURL("image/jpeg", 0.92)).size(width, height),
                    effect = this.data.effectName ? this.model.photofilters.get(this.data.effectName) : null;

                image.filter((add) => filters.PhotoFilters.chain(add, this.data, effect, image));

                let picture = new Image();
                picture.onload = () => resolve(picture);
                picture.onerror = () => resolve(canvas);
                picture.src = "data:image/svg+xml;base64," + window.btoa(unescape(encodeURIComponent(draw.svg())));
            }
            catch (e) {
                resolve(canvas);
            }
        });
    }

    /**
     * The picture in its frame as the stage shows it : an SVG <image> keeps its proportions
     * (preserveAspectRatio "xMidYMid meet"), centred in a frame of other proportions. Such a frame is
     * left by replacing a photo with one of other proportions, the frame of the first kept (creation
     * 4358939, page 165 : a 3 : 4 photo in a frame cut for a 1 : 2 one) ; drawn to the frame, the photo
     * was stretched.
     */
    _contain(x, y, width, height)
    {
        let picture = this._tmpImgcanvas,
            ratio = picture.width / picture.height;

        if (!ratio || !width || !height || Math.abs(ratio - width / height) < 0.005 * ratio)
            return { x : x, y : y, width : width, height : height };

        let fitted = (width / height > ratio) ? { width : height * ratio, height : height } : { width : width, height : width / ratio };

        return { x : x + (width - fitted.width) / 2, y : y + (height - fitted.height) / 2, width : fitted.width, height : fitted.height };
    }

    _loadMask()
    {
        let mask = this.model.masks.find({id: this.data.photomask});
        let maskURL = mask ? mask.thumb : null;
        if (maskURL)
        {
            this._maskimg = new Image();
            this.on("load", this._onMaskDrawn, this._maskimg );
            this.on("error", this._onMaskDrawn, this._maskimg);    
            this._maskimg.src = maskURL;   
        }
        else
            this._onMaskDrawn(false);
    }

    _onMaskDrawn(event)
    {
        // given up on already : the canvas is drawing another page by now
        if (this.late)
            return;

        if(event === true || event.type == "load") 
        {
            this._tmpcontext.drawImage(this._maskimg, 0, 0, this._tmpCanvas.width,  this._tmpCanvas.height);
            this._tmpcontext.globalCompositeOperation = 'source-in';
        }

        // the frame, the picture turned with it : width and height swap at 90 and 270
        let turned = (this.elementRotationInner == 90 || this.elementRotationInner == 270),
            box = this._contain(this.elementXInner, this.elementYInner,
                                turned ? this.elementHeightInner : this.elementWidthInner,
                                turned ? this.elementWidthInner : this.elementHeightInner);

        this._tmpcontext.drawImage(this._tmpImgcanvas, 0, 0, this._tmpImgcanvas.width, this._tmpImgcanvas.height, box.x, box.y, box.width, box.height);

        this.context.save();
        this.context.translate(this.elementX-this.offset, this.elementY-this.voffset);
        this.context.rotate(this.elementRotation*this.TO_RADIANS);
        this.context.translate(-(this.elementX-this.offset), -(this.elementY-this.voffset));
        this.context.drawImage(this._tmpCanvas, this.elementX-this.offset, this.elementY-1-this.voffset, this._tmpCanvas.width+1, this._tmpCanvas.height+1);
        
        if(this.data.borderid>0)
        {
            this.context.lineWidth = this.data.borderid * this.creationSize.ratio;
            this.context.strokeStyle = this.data.side;
            this.context.strokeRect(this.elementX-this.offset-parseInt(this.data.borderid)/2, this.elementY-this.voffset-parseInt(this.data.borderid)/2, this._tmpCanvas.width+parseInt(this.data.borderid), this._tmpCanvas.height+parseInt(this.data.borderid));//for white background
        }

        this.context.restore();

        this._tmpImgcanvas = null;
        this._tmpcontext = null;
        this._tmpCanvas = null;

        this.ready();
    }
});
